// extracted by mini-css-extract-plugin
export default {"productDetailHeader":"LocationHeader_productDetailHeader__z3slC","customIcon":"LocationHeader_customIcon__wOew8","customBackIcon":"LocationHeader_customBackIcon__LJWy9"};